module.exports = __webpack_public_path__ + "img/img7.46a98bfe.png";